import Vue from 'vue';
import TaskStatusSwitcher from './components/TaskStatusSwitcher';
import TaskPrioritySwitcher from './components/TaskPrioritySwitcher';
import store from './store';

export function taskView(task, options) {
  store.commit('setCurrentTask', task);

  if (options.changeStatus) {
    new Vue({
      el: '.task-status-switcher',
      render: h => h(TaskStatusSwitcher),
      store,
    });
  }
  if (options.edit) {
    new Vue({
      el: '.task-priority-switcher',
      render: h => h(TaskPrioritySwitcher),
      store,
    });
  }
}



// WEBPACK FOOTER //
// ./assets/js/tasks.js